const AUTH_COOKIE_NAME = "jwtToken";
const AUTH_COOKIE_MAX_AGE_SECONDS = 86400;

function getCookieValue(name) {
  if (typeof document === "undefined") return null;
  const cookiePrefix = `${name}=`;
  const cookie = document.cookie
    .split(";")
    .map(value => value.trim())
    .find(value => value.startsWith(cookiePrefix));

  if (!cookie) return null;

  return decodeURIComponent(cookie.slice(cookiePrefix.length));
}

function getSecureCookieAttribute() {
  if (typeof window === "undefined" || !window.location || window.location.protocol !== "https:") {
    return "";
  }

  return "; secure";
}

export function persistAuthToken(token) {
  localStorage.token = token;

  if (typeof document !== "undefined") {
    document.cookie = `jwtToken=${encodeURIComponent(token)}; path=/; max-age=${AUTH_COOKIE_MAX_AGE_SECONDS}; samesite=lax${getSecureCookieAttribute()}`;
  }
}

export function removeAuthToken() {
  if (typeof localStorage !== "undefined") {
    localStorage.removeItem("token");
  }

  if (typeof document !== "undefined") {
    document.cookie = `${AUTH_COOKIE_NAME}=; path=/; max-age=0; samesite=lax${getSecureCookieAttribute()}`;
  }
}

export function getStoredAuthToken() {
  if (typeof localStorage !== "undefined") {
    const localStorageToken = localStorage.getItem("token");
    if (localStorageToken && localStorageToken !== "undefined" && localStorageToken !== "null") {
      return localStorageToken;
    }
  }

  const cookieToken = getCookieValue(AUTH_COOKIE_NAME);
  if (cookieToken && typeof localStorage !== "undefined") {
    localStorage.setItem("token", cookieToken);
  }

  return cookieToken;
}
